import { render, staticRenderFns } from "./customer_details.vue?vue&type=template&id=4080b003&scoped=true&"
import script from "./customer_details.vue?vue&type=script&lang=js&"
export * from "./customer_details.vue?vue&type=script&lang=js&"
import style0 from "./customer_details.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./customer_details.vue?vue&type=style&index=1&id=4080b003&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4080b003",
  null
  
)

/* custom blocks */
import block0 from "@/lang/actions.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fcustomers%2Fcustomer_details.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/lang/messages.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fcustomers%2Fcustomer_details.vue"
if (typeof block1 === 'function') block1(component)
import block2 from "./customer_details.vue?vue&type=custom&index=2&blockType=i18n"
if (typeof block2 === 'function') block2(component)

export default component.exports